import useJwt from "@/auth/jwt/useJwt";

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
	// Token stored in sessionStorage. userData also moved to sessionStorage.
	const hasToken =
		sessionStorage.getItem(useJwt.jwtConfig.storageTokenKeyName) ||
		localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName); // legacy fallback
	const userData =
		sessionStorage.getItem("userData") ||
		localStorage.getItem("userData"); // legacy fallback
	return !!(userData && hasToken);
};

export const getUserData = () => {
	const raw =
		sessionStorage.getItem("userData") ||
		localStorage.getItem("userData"); // legacy fallback
	return raw ? JSON.parse(raw) : null;
};

/**
 * userData.role is a human-readable label ("Super Admin"), not the machine
 * slug ("super_admin") — comparing it directly against a slug string never
 * matches. The real slug lives on userData.roles[0].slug. This normalizes
 * both so callers can compare against a lowercase snake_case slug reliably.
 * @param {Object|null} userData
 * @returns {string} normalized role slug, e.g. "super_admin", "owner", "" if unknown
 */
export const getRoleSlug = (userData) => {
	if (!userData) return "";
	const roleSlug = Array.isArray(userData.roles) && userData.roles.length > 0
		? (typeof userData.roles[0] === "object" ? userData.roles[0].slug : userData.roles[0])
		: null;
	if (roleSlug) return roleSlug;
	return (userData.role || "").toLowerCase().replace(/\s+/g, "_");
};

export const isSuperAdminUser = (userData) => getRoleSlug(userData) === "super_admin";

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole) => {
	if (userRole) {
		return "/";
	}
	return { name: "auth-login" };
};
